export class Map {
  constructor() {
    this.map = '[data-map]';
    this.countries = 'data-map-id';
    this.tooltip = '[data-short-tooltip]';
    this.popup = '[data-popup]';
    this.popupImage = '[data-popup-image]';
    this.popupTitle = '[data-popup-title]';
    this.popupContent = '[data-popup-content]';
    this.popupClose = '[data-popup-close]'
    this.circle = '[data-map-circle]';
    this.names = '[data-map-names]';
    this.nameID = 'data-name-id';
    this.info = '[data-map-info-list]';
    this.infoID = 'data-map-info-id';
    this.countryImg = '[data-map-info-img]';
    this.countryContent = '[data-map-info-content]';
    this.activeCountry = null;
    // this.popupClose = null;
    // this.checkPopupContainer2 = null;
    this.eventListeners();
  }
  eventListeners() {
    if(!document.querySelector(this.map) && !document.querySelector(this.names)) {
      return;
    }

    this.setActiveCountry();
    
    $(document).on('mouseenter', `[${this.countries}]`, (e) => {
      const ID = e.target.getAttribute(this.countries);
      if(!this.checkHasName(ID) || e.target === this.activeCountry) {
        return
      }

      if(this.activeCountry) {
        this.closePopup();
      }
      
      const left = e.target.getBoundingClientRect().left + (e.target.getBoundingClientRect().width / 2);
      const top = e.target.getBoundingClientRect().top;
      const tooltip = document.querySelector(this.tooltip);

      tooltip.innerHTML = this.checkHasName(ID).innerHTML;
      tooltip.classList.add('active');
      tooltip.style.left = left + 'px';
      tooltip.style.top = top + 'px';

      if ($(window).width() < 767) {
        $(document).on('scroll.closeTooltip', () => this.closeTooltip());
      }
    });

    $(document).on('mouseout', `[${this.countries}]`, () => {
      this.closeTooltip();

      if ($(window).width() < 767) {
        $(document).off('scroll.closeTooltip');
      }
    });

    $(document).on('click', `[${this.countries}]`, (e) => {
      const ID = e.target.getAttribute(this.countries);
      if(!this.checkHasName(ID) || $(window).width() < 767) {
        return
      }

      this.activeCountry = e.target;
      e.target.classList.add('active');

      document.querySelector(this.tooltip).classList.remove('active');
      // const left = e.target.getBoundingClientRect().left + (e.target.getBoundingClientRect().width / 2);
      const left = e.target.getBoundingClientRect().left;
      const width = e.target.getBoundingClientRect().width;
      const right = $(window).width() - left - width;
      const top = e.target.getBoundingClientRect().top + (e.target.getBoundingClientRect().height / 2);
      const circle = document.querySelector(this.circle);
      const popup = document.querySelector(this.popup);

      popup.querySelector(this.popupTitle).innerHTML = this.checkHasName(ID).innerHTML;

      circle.classList.add('active');
      popup.style.top = top + 'px';
      circle.style.left = left + 'px';
      circle.style.top = top + 'px';
      popup.classList.add('active');

      const containerOffset = Number(getComputedStyle(document.querySelector(':root')).getPropertyValue('--offset').trim());
      const containerWidth = popup.getBoundingClientRect().width + containerOffset;

      if(left < containerWidth && right > containerWidth) {
        popup.classList.add('right');
        popup.style.right = right + 'px';
        popup.style.left = 'auto';
      }else if(left < containerWidth && right < containerWidth) {
        popup.classList.add('top');
        popup.style.right = 'auto';
        popup.style.left = left + 'px';
        popup.style.top = e.target.getBoundingClientRect().top + 'px';
      } else {
        popup.style.right = 'auto';
        popup.style.left = left + 'px';
      }

      // this.popupClose = this.closePopup.bind(this);
      // this.checkPopupContainer2 = (e) => this.checkPopupContainer(e);
      // window.addEventListener('scroll', this.popupClose);
      // document.addEventListener('click', this.checkPopupContainer2);

      $(document).on('scroll.popupClose', () => this.closePopup());
      $(document).on('click.popupContainer', (e) => this.checkPopupContainer(e));

      if(!this.checkHasInfo(ID)) {
        return
      }

      const image = this.checkHasInfo(ID).querySelector(this.countryImg);
      const content = this.checkHasInfo(ID).querySelector(this.countryContent);
       
      popup.querySelector(this.popupImage).innerHTML = image ? image.innerHTML : '';
      popup.querySelector(this.popupContent).innerHTML = content ? content.innerHTML : '';
    });

    $(document).on('click', `${this.popupClose}`, () => {
      this.closePopup();
    });
  }

  setActiveCountry() {
    let activeCountry = [];
    document.querySelector(this.names).content.querySelectorAll('[' + this.nameID + ']').forEach((el) => {
      activeCountry.push(el.getAttribute(this.nameID));
    })

    document.querySelectorAll('[' + this.countries + ']').forEach(el => {
      if(activeCountry.find(elem => elem === el.getAttribute(this.countries))) {
        el.classList.add('is-country');
      }
    })
  }
   
  checkHasId(id, elemContainer, elemList) {
    const names = document.querySelector(elemContainer).content.querySelectorAll('[' + elemList + ']');
    let elem = false;
    names.forEach((el) => {
      if(el.getAttribute(elemList) === id) {
        elem = el;
      }
    });
    return elem;
  }

  checkHasName(id) {
    let name_by_id = this.checkHasId(id, this.names, this.nameID);
    return name_by_id;
  }

  checkHasInfo(id) {
    return this.checkHasId(id, this.info, this.infoID);
  }

  closePopup() {
    if(!this.activeCountry) {
      return
    }
    document.querySelector(this.popup).classList.remove('active');
    document.querySelector(this.popup).classList.remove('right');
    document.querySelector(this.popup).classList.remove('top');
    document.querySelector(this.circle).classList.remove('active');
    this.activeCountry.classList.remove('active');
    this.activeCountry = null;

    // window.removeEventListener('scroll', this.popupClose);
    // document.removeEventListener('click', this.checkPopupContainer2);
    $(document).off('scroll.popupClose');
    $(document).off('click.popupContainer');
  }

  closeTooltip() {
    document.querySelector(this.tooltip).classList.remove('active');
  }

  checkPopupContainer(e) {
    const targetEl = e.target;
    if(!targetEl.closest(this.popup) && !targetEl.closest(this.circle) && targetEl.closest(`[${this.countries}]`) !== this.activeCountry
      && targetEl.hasAttribute(this.countries) !== this.activeCountry) {
      this.closePopup();
    }
  }
}



// WEBPACK FOOTER //
// ./scripts/main-modules/map.js